import { ConfigurationItem } from "@sourceful/shared-types";

export const SFE_GUEST_CONFIG_ITEM = "SFE_GUEST_CONFIG_ITEMS";

class GuestConfigItemManager {
  private getRawItem() {
    if (typeof window === "undefined") return;

    const raw = window.localStorage.getItem(SFE_GUEST_CONFIG_ITEM);
    return raw;
  }

  async getItem(): Promise<ConfigurationItem | null> {
    const raw = this.getRawItem();
    let item = raw ? JSON.parse(raw) : null;

    if (!item) return null;

    return item;
  }

  doesItemExist(): boolean {
    const item = this.getRawItem();
    return !!item;
  }

  setItem(item: ConfigurationItem | null) {
    if (typeof window === "undefined") return;

    if (!item) {
      return this.removeItem();
    }

    window.localStorage.setItem(SFE_GUEST_CONFIG_ITEM, JSON.stringify(item));
  }

  removeItem() {
    if (typeof window === "undefined") return;

    window.localStorage.removeItem(SFE_GUEST_CONFIG_ITEM);
  }
}

export default GuestConfigItemManager;
